<template>
  <div class="contents_wrapper">
    <Header :title="'その他'"/>
    <div class="contents">
      <div class="setting_main">
        <div class="setting_main_nav">
          <a v-bind:href="termsUrl" target="_blank" class="setting_link_text arrow">
            <div class="setting_link">利用規約</div>
          </a>
          <a v-bind:href="privacyPolicyUrl" target="_blank" class="setting_link_text arrow">
            <div class="setting_link">プライバシーポリシー</div>
          </a>
          <br>
          <a href="javascript:void(0)" @click="logout" class="setting_link_text arrow">
            <div class="setting_link">ログアウト</div>
          </a>
        </div>
        <div class="setting_line">
          <div>ユーザ</div>
          <div>{{account}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accountService from "../services/accountService";
import loggerService from "../services/loggerService";
import Header from "../components/Header.vue";
import appConfig from "../appConfig";
import Store from "../store";

const store = new Store();
export default {
  components: {
    Header
  },
  data: function() {
    return {
      usageUrl: appConfig.PageUrl.Usage,
      termsUrl: appConfig.PageUrl.Terms,
      privacyPolicyUrl: appConfig.PageUrl.PrivacyPolicy,
      account: store.account
    };
  },
  created: function() {
    loggerService.pageView("Settings");
  },
  methods: {
    logout: function() {
      loggerService.info("logout");
      var _this = this;
      accountService.logout(() => {
        _this.$router.push({
          path: `/login`
        });
      });
    }
  }
};
</script>

<style lang="scss">
.setting_link {
  width: 80%;
  margin: 30px auto;
  background-color: $btnColor;
  border-radius: 5px;
  padding: 14px;
}

.setting_link_text {
  font-size: 18px;
  color: #fff;
  width: 100%;
  padding-bottom: 8px;
}

.arrow::before {
  right: 5px;
  top: 29%;
}

.setting_line {
  width: 80%;
  font-size: 16px;
  margin: 5px auto;
  padding-top: 10px;
}
</style>